var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69822 14.8829C9.40602 14.8826 11.0646 14.3566 12.4099 13.3887L16.6395 17.28L18 16.0283L13.7704 12.1371C14.823 10.8993 15.395 9.37302 15.3955 7.80143C15.3955 3.89689 11.9423 0.719971 7.69822 0.719971C3.45415 0.719971 0.000976562 3.89689 0.000976562 7.80143C0.000976562 11.706 3.45415 14.8829 7.69822 14.8829ZM7.69822 2.49034C10.882 2.49034 13.4711 4.87236 13.4711 7.80143C13.4711 10.7305 10.882 13.1125 7.69822 13.1125C4.51445 13.1125 1.92529 10.7305 1.92529 7.80143C1.92529 4.87236 4.51445 2.49034 7.69822 2.49034Z",
    fill: "#C4CACD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.33455310e45edb64bbb5c65e5195e373.svg";
export { ForwardRef as ReactComponent };